<nz-slider [nzMarks]="numberSliderMarks" nzStep="1" nzMin="1" nzMax="10" [(ngModel)]="sliderValue" (ngModelChange)="onSliderModelChange()"></nz-slider>
